/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Definition of colors for appointments
 * @export
 * @interface AppointmentColor
 */
export interface AppointmentColor {
    /**
     * UUID of the color schema
     * @type {string}
     * @memberof AppointmentColor
     */
    uuid?: string;
    /**
     * State of the color
     * @type {boolean}
     * @memberof AppointmentColor
     */
    active?: boolean;
    /**
     * Text color in appointement card
     * @type {string}
     * @memberof AppointmentColor
     */
    textColor?: string;
    /**
     * Background color in appointement card
     * @type {string}
     * @memberof AppointmentColor
     */
    backgroundColor?: string;
    /**
     * Trim color in appointement card
     * @type {string}
     * @memberof AppointmentColor
     */
    trimColor?: string;
    /**
     * Text color in appointement card
     * @type {string}
     * @memberof AppointmentColor
     */
    disabledTextColor?: string;
    /**
     * Background color in appointement card
     * @type {string}
     * @memberof AppointmentColor
     */
    disabledBackgroundColor?: string;
    /**
     * trim color in appointement card
     * @type {string}
     * @memberof AppointmentColor
     */
    disabledTrimColor?: string;
    /**
     * Indicates if this is the default color scheme
     * @type {boolean}
     * @memberof AppointmentColor
     */
    isDefault?: boolean;
}

/**
 * Check if a given object implements the AppointmentColor interface.
 */
export function instanceOfAppointmentColor(value: object): value is AppointmentColor {
    return true;
}

export function AppointmentColorFromJSON(json: any): AppointmentColor {
    return AppointmentColorFromJSONTyped(json, false);
}

export function AppointmentColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentColor {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'active': json['active'] == null ? undefined : json['active'],
        'textColor': json['textColor'] == null ? undefined : json['textColor'],
        'backgroundColor': json['backgroundColor'] == null ? undefined : json['backgroundColor'],
        'trimColor': json['trimColor'] == null ? undefined : json['trimColor'],
        'disabledTextColor': json['disabledTextColor'] == null ? undefined : json['disabledTextColor'],
        'disabledBackgroundColor': json['disabledBackgroundColor'] == null ? undefined : json['disabledBackgroundColor'],
        'disabledTrimColor': json['disabledTrimColor'] == null ? undefined : json['disabledTrimColor'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
    };
}

export function AppointmentColorToJSON(json: any): AppointmentColor {
    return AppointmentColorToJSONTyped(json, false);
}

export function AppointmentColorToJSONTyped(value?: AppointmentColor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'active': value['active'],
        'textColor': value['textColor'],
        'backgroundColor': value['backgroundColor'],
        'trimColor': value['trimColor'],
        'disabledTextColor': value['disabledTextColor'],
        'disabledBackgroundColor': value['disabledBackgroundColor'],
        'disabledTrimColor': value['disabledTrimColor'],
        'isDefault': value['isDefault'],
    };
}

